import { setInputMask } from '../../../components/views/chat/actions';

const ShowOptions = {
    name: 'showOptions',
    exec: (customMessage) => {
        customMessage.contentType = 'Buttons';
        customMessage.message = 'Przyciski';
        setInputMask('disableInput');
    }
};

export default ShowOptions;
